var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-9',[_c('h2',{staticClass:"title"},[_vm._v("采集实时数据量")]),_c('div',{ref:"lineBarChart",staticStyle:{"width":"600px","height":"300px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }